var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0619 11.4999C13.1336 13.1076 11.6047 14.2807 9.81145 14.7612M14.0619 11.4999C14.9901 9.8921 15.2416 7.98146 14.7612 6.18824M14.0619 11.4999L9.34696 8.77763M9.81145 14.7612C8.01823 15.2416 6.10759 14.9901 4.49983 14.0619M9.81145 14.7612L8.40242 9.50236M4.49983 14.0619C2.89211 13.1336 1.71898 11.6047 1.23852 9.81145M4.49983 14.0619L7.22206 9.34696M14.7612 6.18824C14.2807 4.39502 13.1076 2.8661 11.4999 1.93781M14.7612 6.18824L9.50236 7.59727M11.4999 1.93781C9.8921 1.00959 7.98146 0.758048 6.18824 1.23852M11.4999 1.93781L8.77763 6.65273M9.34696 8.77763C9.14068 9.1349 8.80092 9.39559 8.40242 9.50236M9.34696 8.77763C9.55324 8.42035 9.60913 7.99576 9.50236 7.59727M1.23852 9.81145C0.758048 8.01823 1.00959 6.10759 1.93781 4.49983M1.23852 9.81145L6.49733 8.40242M1.93781 4.49983C2.8661 2.89211 4.39502 1.71898 6.18824 1.23852M1.93781 4.49983L6.65273 7.22206M7.22206 9.34696C7.57934 9.55324 8.00393 9.60913 8.40242 9.50236M7.22206 9.34696C6.86479 9.14068 6.6041 8.80092 6.49733 8.40242M6.18824 1.23852L7.59727 6.49733M6.65273 7.22206C6.44646 7.57934 6.39056 8.00393 6.49733 8.40242M6.65273 7.22206C6.85901 6.86479 7.19877 6.6041 7.59727 6.49733M8.77763 6.65273C9.1349 6.85901 9.39559 7.19877 9.50236 7.59727M8.77763 6.65273C8.42035 6.44646 7.99576 6.39056 7.59727 6.49733",
    stroke: "#DDDDEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheel);
export default __webpack_public_path__ + "static/media/wheel.91f5461e2fcc8bd9f88d7eaf736f00b0.svg";
export { ForwardRef as ReactComponent };